// Snapshot of Keep Me Out's Google Play numbers. Re-check on every deploy day (G5).
// - rating: Play Console "Default Google Play rating" 4.476 -> shown as 4.5 (owner, 2026-09-18). This is Google's
//   headline rating; country listings can show their own (e.g. US 4.3), hence the "vary by country" footnote.
//   If the default rating drops below 4.45, update it (or set MK_FLAGS.SHOW_PLAY_RATING to false).
// - ratings: 12,815 users have rated the app (Play Console "Users"; the public listing shows "12.8K"). Only 5,502 of
//   those left a written review, so the site says "ratings", never "reviews", for this number.
// - 1M+ downloads and 10,000+ four/five-star ratings come from the public Play listing.
export const PLAY_FACTS = {
  asOf: 'Sep 2026',
  asOfLong: 'September 2026',
  downloads: '1M+',
  ratings: '12.8K',
  highRatings: '10,000+',
  rating: '4.5',
  since: '2016',
  languages: '10',
};
